module.exports = __webpack_public_path__ + "img/wahl_fristilt.7dea2db5.png";